/*
  Discount code field in the cart drawer.

  Uses the cart API's `discount` parameter on /cart/update.js. Shopify answers
  with `discount_codes`, each flagged `applicable`. A code that does not apply
  is removed again straight away and the customer is told, so an invalid code
  never sits silently on the cart. After a change the drawer re-renders from
  the returned sections, exactly as adding a product does.
*/
if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="discount"]');
      this.button = this.querySelector('[type="submit"]');
      this.error = this.querySelector('.cart-drawer__discount-error');
      this.applied = (this.dataset.codes || '').split(',').map((c) => c.trim()).filter(Boolean);

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-discount-remove]');
        if (remove) this.removeCode(remove.dataset.discountRemove);
      });
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message || '';
      this.error.hidden = !message;
    }

    setBusy(busy) {
      if (this.button) this.button.disabled = busy;
      if (this.input) this.input.disabled = busy;
    }

    onSubmit(event) {
      event.preventDefault();
      const code = (this.input.value || '').trim().toUpperCase();
      if (!code) return;
      if (this.applied.map((c) => c.toUpperCase()).includes(code)) {
        this.showError('That code is already applied.');
        return;
      }
      this.updateCodes(this.applied.concat(code), code);
    }

    removeCode(code) {
      this.updateCodes(this.applied.filter((c) => c.toUpperCase() !== (code || '').toUpperCase()), null);
    }

    updateCodes(codes, newCode) {
      this.showError('');
      this.setBusy(true);
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : ['cart-drawer', 'cart-icon-bubble'];
      const config = window.fetchConfig ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };

      const post = (list) => {
        config.body = JSON.stringify({ discount: list.join(','), sections: sections, sections_url: window.location.pathname });
        return fetch(window.routes.cart_update_url, config).then((r) => r.json());
      };

      post(codes)
        .then((response) => {
          if (newCode) {
            const entry = (response.discount_codes || []).find((d) => d.code.toUpperCase() === newCode);
            if (!entry || !entry.applicable) {
              /* Put the cart back how it was, then explain. */
              return post(this.applied).then(() => {
                this.setBusy(false);
                this.input.focus();
                this.showError("That code can't be used on this order.");
                return null;
              });
            }
          }
          return response;
        })
        .then((response) => {
          if (!response) return;
          if (drawer && response.sections) {
            drawer.renderContents(response);
          } else {
            window.location.reload();
          }
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: response });
          }
        })
        .catch(() => {
          this.setBusy(false);
          this.showError('Sorry, something went wrong. Please try again.');
        });
    }
  }

  customElements.define('cart-discount', CartDiscount);
}
